import { REPORT } from "../_constants/actionConstants";

const reportsInitialState = {
  openReports: {}, // Normalized by tabId
  fetching: false,
  error: null
};

export const reducer = (state = reportsInitialState, action) => {
  switch (action.type) {
    case REPORT.CREATE:
      return { ...state, fetching: true };

    case REPORT.CREATE_FULFILLED:
      return {
        ...state,
        openReports: {
          ...state.openReports,
          [action.tabId]: action.report
        },
        fetching: false
      };

    case REPORT.CREATE_REJECTED:
      return { ...state, fetching: false };

    case REPORT.CLOSE:
      const openReports = { ...state.openReports };
      delete openReports[action.tabId];
      return {
        ...state,
        openReports,
        fetching: false
      };

    case REPORT.CLEAR_ALL_REPORT_DATA:
      return reportsInitialState;

    default:
      return state;
  }
};
